export default __webpack_public_path__ + "static/media/total_value.4e9539ef.svg";